export default __webpack_public_path__ + "static/contributor-of-the-year-667ffd075d75b6486532d5ed812f320b.png";